export default __webpack_public_path__ + "static/media/cif-to.6d31c827.svg";